import { DatePipe } from '@angular/common';
import { Component, EventEmitter, Inject, ViewChild, ViewEncapsulation } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { AddLocationComponent } from '../add-location/add-location.component';
import { MatCalendarCellClassFunction, MatDatepicker, MatDatepickerInputEvent } from '@angular/material/datepicker';
import { RosterShiftComponent } from '../roster-shift/roster-shift.component';
import { RecruiterService } from 'src/app/services/recruiter/recruiter.service';
import { CommonService } from 'src/app/services/common/common.service';
import { AppService } from 'src/app/services/app/app.service';
import { RecConfirmModalComponent } from '../rec-confirm-modal/rec-confirm-modal.component';
import { PaginationInstance } from 'ngx-pagination';
import { GlobalService } from 'src/app/services/global/global.service';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import { ViewPastHistoryComponent } from '../view-past-history/view-past-history.component';
import { JobService } from 'src/app/services/job/job.service';
import { JobDataAdd } from 'src/app/model/job_data';
import { NgxSpinnerService } from 'ngx-spinner';
import { NgSelectConfig } from '@ng-select/ng-select';
import { id } from 'date-fns/locale';
import { DeleteItemComponent } from '../../delete-item/delete-item.component';
import { CompanyLocationComponent } from '../company-location/company-location.component';
import { JobSummaryComponent } from '../job-summary/job-summary.component';
import { JobAcceptService } from 'src/app/services/job-accept/job-accept.service';
import { IDropdownSettings } from 'ng-multiselect-dropdown';
import { ScheduleShiftConfirmationComponent } from '../schedule-shift-confirmation/schedule-shift-confirmation.component';
import { ViewQuestionAnswerComponent } from '../view-question-answer/view-question-answer.component';
import { ViewEmployeeComponent } from '../../view-employee/view-employee.component';
enum ShiftType {
  AssignEmployee = "assign_employee",
  AssignFavEmployee = "assign_fav_employee",
  Single = "single",
  Multiple = "multiple",
  AdditionalResource = "additional_resource",
  InstantHire = "instant_hire",
  ShiftTemplate = "shift_template" // from week view user is able to add template of the shift
}
enum WeekShiftType {
  Category = "category",
  User = "user",
  Location = "location",
  Company = "company",
}
// Add single shift
// u_t : 1
// e_typ : 1
// assign : 0,1

// Offer to Favorites
// u_t : 1
// e_typ : 0
// assign : 0,1

// Hire additional resource
// u_t: 2 
// e_typ:0,1
// assign : 0
@Component({
  selector: 'app-add-shift',
  templateUrl: './add-shift.component.html',
  styleUrls: ['./add-shift.component.scss'],
})

export class AddShiftComponent {
  panelOpenState = false;
  public currentTab: string = 'shift_details';
  public employeeArr: any[] = [

  ]
  public filterEmployeeArr: any[] = [];
  public recruiterArr: any[] = [
    // {
    //   "employee_id": 7671,
    //   "first_name": "vishva 5",
    //   "last_name": "Recruiter",
    //   e: ""
    // },
    // {
    //   "employee_id": 0,
    //   "first_name": "Test",
    //   "last_name": "Recruiter",
    //   e: ""
    // },
    // {
    //   "employee_id": 7668,
    //   "first_name": "vishva3",
    //   "last_name": "Recruiter",
    //   e: ""
    // },
  ]
  public activityArr: any[] = [];
  public filterRecArr: any[] = [];
  public templateArr: any[] = []
  public addForm!: FormGroup;
  @ViewChild('picker', { static: true }) _picker!: MatDatepicker<Date>;
  public daysSelectedDisplay = '';
  public shiftDates: any[] = []
  public daysSelected: any = [];
  selectedDates: any[] = [];
  public locArr: any[] = [];
  public categoryArr: any[] = [];
  public subCategoryArr: any[] = [];
  public dressCodeArr: any[] = [];

  public shiftType!: string;
  public repeatText!: string;
  public repeatData: any;
  public weekShiftType!: WeekShiftType;

  public displayedColumns: string[] = ['employee', 'status', 'action', 'more'];
  public displayedColumnsShiftSent: string[] = ['employee', 'status'];

  public dataSource = new MatTableDataSource();
  public dataSourceShiftSent = new MatTableDataSource();
  public shiftSentCrone: boolean = false;

  public count!: any;
  public countShiftSent!: any;
  public employeeListFlag: boolean = false;
  public isSaving: boolean = false;

  public isNoRepeat: boolean = false;

  @ViewChild(MatPaginator) paginator!: MatPaginator;
  @ViewChild(MatSort) sort!: MatSort;



  public pageSizeOptions = GlobalService.pageSizeOptions;
  public maxPaginationSize = GlobalService.maxPaginationSize
  public config: PaginationInstance = {
    itemsPerPage: this.pageSizeOptions[0],
    currentPage: 0,
  };
  // this are the parameter or fields used while add/edit based on the shift type i am allowing to hide or show that parameter.
  // to make any chnages add or remove the shift type. Also you can add new types
  //
  public shiftParametersAllowed = {
    shift_type: [ShiftType.AdditionalResource],
    single_date: [ShiftType.Single, ShiftType.ShiftTemplate],
    multiple_dates: [ShiftType.Multiple, ShiftType.InstantHire, ShiftType.AssignEmployee, ShiftType.AssignFavEmployee, ShiftType.AdditionalResource],
    select_emp: [ShiftType.AssignEmployee, ShiftType.AssignFavEmployee, ShiftType.Multiple, ShiftType.Single],
    send_to_fav: [ShiftType.AssignFavEmployee],
    instant_hire: [ShiftType.Multiple, ShiftType.InstantHire],
    employee_shift_type: [ShiftType.Multiple]
  }

  public objData = {
    shiftSent: {
      operand: "or",
      arr: [],
      isFilterShow: false,
      sh: "",
      previousInputValue: "",
      itemsPerPage: 12,
      currentPage: 1,
      maxPaginationSize: GlobalService.maxPaginationSize,
      count: 1,
    },
    shiftREquest: {
      operand: "or",
      arr: [],
      isFilterShow: false,
      sh: "",
      previousInputValue: "",
      itemsPerPage: 12,
      currentPage: 1,
      maxPaginationSize: GlobalService.maxPaginationSize,
      count: 1,
    },
  };


  // this are the types that will be sent from the Job Calendar it is used to hide and show the tabs
  // based on type of the modal being opened from job calendar i am hide/showing the tabs
  // you can add the more as per need or remove any if you don't want any of the tab.
  public typeAllowed = {
    add: ["shift_details", "template"],
    edit: ["shift_details", "activity", "shift_request",],
    open_shift: ["shift_details", "shift_request", "shift_sent", "activity"],
    add_template: ["shift_details", "template"], //only used from week view where user can add the template
    edit_template: ["shift_details",],
  }
  // list of all the tabs this modal possess. If need to add any more tabs then please add it here.
  public tabsArr = [
    { name: "Shift Details", value: "shift_details" },
    { name: "Template", value: "template" },
    { name: "Shift Sent", value: "shift_sent" },
    { name: "Shift Request", value: "shift_request" },
    { name: "Activity", value: "activity" },
  ]

  public setValueForShift = {
    j_c: [WeekShiftType.Category],
    cname: [WeekShiftType.Company],
    user: [WeekShiftType.User],
    add: [WeekShiftType.Location]
  }
  public idObj = {
    j_id: "",
    comm_id: '',
    em_i: ''
  }
  public jobData = {}
  public userType!: string;
  public adminType!: string;

  public errorMsg!: string;
  public errorType = {
    qty: "Quantity should be equal or greater then the number of employees to whom shiftis being assignedd."
  }
  public shiftStatus: any[] = [
    { name: "Open", value: 0 },
    { name: "Pause", value: 1 },
    { name: "Terminate", value: 2 },
  ]
  public employeeStatus: any[] = [
    { name: "Mark as absent", value: "0" },
    { name: "Mark as early", value: "1" },
    { name: "Mark as late", value: "2" },
    { name: "Mark as sick", value: "3" },
  ]
  public viewByData = {
    category: [],
  }
  public companyArr: any[] = [];
  public isEditTemplate: boolean = false;
  public dropdownSettings: IDropdownSettings = {};
  selectedCompanyId: number = 0;
  public isSpinnerLoading: boolean = false;
  public isSpinnerLoading2: boolean = false;


  constructor(private dialogRef: MatDialogRef<AddShiftComponent>, private datePipe: DatePipe, private fb: FormBuilder,
    private dialog: MatDialog, @Inject(MAT_DIALOG_DATA) public dialogData: any, private recruiterService: RecruiterService, private commonService: CommonService,
    private appService: AppService, private jobService: JobService, private spinner: NgxSpinnerService, private jobAcceptService: JobAcceptService,
    private selectConfig: NgSelectConfig) { }

  ngOnInit(): void {
    this.dropdownSettings = {
      idField: 'add',
      // textField: 'add',
      textField: 'add_prop',
      // below setting will help to enable search filter in multi select dropdown
      allowSearchFilter: true,
      singleSelection: true,
    };
    this.selectConfig.notFoundText = 'Please fill all the above shift details to get the list';
    this.addForm = this.fb.group(({
      //u_t for 5 = recruiter favourite employee, 4 = favourite employee, 3 = specific employee, 2= recruiter employee, 1 = own employee, 0 = freelance employee 
      "user_type": ["2", Validators.required],
      "j_n": ["Relief Staff", Validators.required],
      "qty": ['', Validators.required],
      "j_c": ['', Validators.required],
      "j_sc": ['', Validators.required],
      'st_dt': '',
      'st_ti': '',
      'ed_ti': '',
      "all_day": [false],
      "add": ['', Validators.required],
      "notes": "",
      'shift_task': this.fb.array([]),
      'que': this.fb.array([]),
      'date': this.fb.array([]),
      'ins_h': [false],
      's_rec': [false],
      'fav_emp_typ': ['1'],
      'emp': [[]],
      'dr_c': ['', Validators.required],
      'city': [''],
      'country': [],
      'lat': [],
      'long': [],
      "wages": "19",
      "new_wages": "23.37",
      "mi_sh": "04:00",
      'e_typ': [],
      'rec_emp_typ': ['0'],
      'own_emp_typ': ['2'], //by default send to all
      'co_i': [],
      'pause': [],
      'rec': [[]],
      "prop_n": "",
      "experience": ""
      //'em_st': [],
    }))

    if (this.dialogData.addType == 'single') {
      this.addForm.get('st_ti')?.setValidators([Validators.required])
      this.addForm.get('ed_ti')?.setValidators([Validators.required])
    }
    this.getDatesValidation();
    this.getCategoryList();
    this.getAddressDetails();
    var userInfo;
    try {
      const userInfoRaw = this.appService.getData('training-portal.userInfo');
      if (userInfoRaw) {
        userInfo = JSON.parse(userInfoRaw);
      }
    } catch (e) {
      console.error('Failed to parse user info:', e);
    }
    const rawData = this.appService.getData('training-portal.iframeUserInfo');
    const adminData = this.appService.getSessionData('isAdmin');
    const adminInfo = rawData ? JSON.parse(rawData) : null;

    if (adminInfo?.u_typ == '3' && adminData) {
      this.adminType = 'admin';

    } else {
      this.adminType = '';
    }


    // this.userType = userInfo.u_typ == 0 ? 'company' : 'recruiter';
    this.userType = userInfo?.u_typ == 0 ? 'company' : (userInfo.u_typ == 1 ? 'recruiter' : 'admin');

    if (this.userType === 'recruiter' || this.adminType == 'admin') {
      this.getCompanyList();
    }
    if ((this.addForm.get('fav_emp_typ')?.value == '1' || this.addForm.get('fav_emp_typ')?.value == '0') && this.dialogData.addType != 'assign_fav_employee') {
      this.employeeListFlag = true;
      this.getEmployeeList()
    }
    if (this.dialogData) {
      this.tabsArr = this.tabsArr.filter(item => { return this.typeAllowed[this.dialogData.modalType].includes(item.value) })
    }


    if (this.dialogData) {
      if (this.dialogData.date?.date) {
        this.addForm.get('st_dt')?.setValue(this.dialogData.date.date);
      }
      if (this.dialogData.addType) {
        this.shiftType = this.dialogData.addType;
        switch (this.dialogData.addType) {
          case 'instant_hire':
            this.addForm.get('ins_h')?.setValue(true);
            break;
          case 'assign_fav_employee':
            this.filterEmployeeArr = this.filterEmployeeArr.filter(item => item.is_f == 1);
            break;
          case 'additional_resource':
            this.getRecruiterList();
            break;
          case 'shift_template':
            this.getCategoryList();
            //inside the get Category list job sub category was to be set hence onSelectTemplate Method is called
            // this.onSelectTemplate(this.dialogData.item);
            break;
        }
      }
      if (this.dialogData?.shift_data?.u_t == 2) {
        this.getRecruiterList();
      }
      if (this.dialogData.shift_data) {
        this.jobData = this.dialogData.shift_data;
        Object.assign(this.idObj, {
          j_id: this.dialogData.shift_data.id,
          comm_id: this.dialogData.shift_data.comm_id,
          em_i: this.dialogData.shift_data.em_i
        });
        this.getJobDetails();
      }
      if (this.dialogData.viewType === 'user' || this.dialogData.viewType === 'c_user') {
        this.getEmployeeList();
      }
      if (this.dialogData.modalType == 'edit_template') {
        this.isEditTemplate = true;
        this.dialogData.viewType = 'category'
        Object.keys(this.dialogData).forEach(key => {
          if (key in this.addForm.value) {
            this.addForm.get(key)?.setValue(this.dialogData[key]);
            // slicing the minutes as otherwise it was not working
            if (key == 'st_ti' || key == 'ed_ti') {
              this.addForm.get(key)?.setValue(this.dialogData[key].slice(0, 5))
            }
          }
        });
      }
    }

    if (this.dialogData) {
      if (this.dialogData.tabType == 'shift_r') {
        setTimeout(() => {
          this.currentTab = 'shift_request';
          this.shiftRequestList()
        }, 100)
      }
    }

    // [change a]
    if (this.shiftDatesFb.length === 0 && (this.dialogData.addType == "assign_fav_employee" || this.dialogData.addType == "instant_hire" || this.dialogData.addType == "multiple" ||
      this.dialogData.addType == "additional_resource"
    )) {
      const today = new Date();
      const dateSelected = this.getDateOnly(today);
      this.addForm.get('st_dt')?.setValue(dateSelected);
      const datesForm = this.fb.group({
        'display_dt': [this.getDispalyDateOnly(today), Validators.required],
        'date': [dateSelected, Validators.required],
        's_sti': ['', Validators.required],
        'e_eti': ['', Validators.required],
      });

      this.applyConditionalValidation(datesForm);
      this.shiftDatesFb.push(datesForm);
    }


    if (this.dialogData.addType == 'assign_fav_employee') {
      this.addForm.get('fav_emp_typ')?.setValue('0')
    }
  }

  get shiftQue(): FormArray {
    return this.addForm.get('que') as FormArray;
  }
  get shiftTasks(): FormArray {
    return this.addForm.get('shift_task') as FormArray;
  }
  get shiftDatesFb(): FormArray {
    return this.addForm.get('date') as FormArray;
  }
  isControlHasError(controlName: string, validationType: string): boolean {
    return this.appService.isControlHasError(this.addForm, controlName, validationType);
  }
  isParameterAllowed(value) {
    if (this.shiftParametersAllowed[value].includes(this.shiftType)) {
      return true;
    }
    return false;
  }
  getDatesValidation() {
    // if shift type is single then date is required or else it is not.
    if (this.shiftType == 'single') {
      this.addForm.get('st_dt')?.setValidators([Validators.required]);
      // if shift type is single date and all day is true then start and end time is not required or else start and end time is required
      this.addForm.get('all_day')?.valueChanges.subscribe((val) => {
        if (val == true) {
          this.addForm.get('st_ti')?.clearValidators();
          this.addForm.get('ed_ti')?.clearValidators();
        } else {
          this.addForm.get('st_ti')?.setValidators([Validators.required]);
          this.addForm.get('ed_ti')?.setValidators([Validators.required]);
        }
        this.addForm.get('st_ti')?.updateValueAndValidity();
        this.addForm.get('ed_ti')?.updateValueAndValidity();
      });
      if (this.addForm.get('all_day')?.value == false) {

        this.addForm.get('st_ti')?.setValidators([Validators.required]);
        this.addForm.get('ed_ti')?.setValidators([Validators.required]);

        this.addForm.get('st_ti')?.updateValueAndValidity();
        this.addForm.get('ed_ti')?.updateValueAndValidity();
      }
    }
    else {
      this.addForm.get('st_dt')?.clearValidators()
    }
    this.addForm.get('st_dt')?.updateValueAndValidity();
  }
  addDates(): void {
    // if you make any changes in this function please make sure you make and check setFormArray function also
    // this function is not used to add dates but have kept here so that if needed can be added easily
    const datesForm = this.fb.group({
      'display_dt': ['', Validators.required],
      'date': ['', Validators.required],
      's_sti': ['', Validators.required],
      'e_eti': ['', Validators.required],
    });
    this.applyConditionalValidation(datesForm)
    this.shiftDatesFb.push(datesForm);
  }
  applyConditionalValidation(control: AbstractControl) {
    const s_sti = control.get('s_sti');
    const e_eti = control.get('e_eti');
    const all_day = this.addForm.get('all_day')

    //extra condition for date selection [added by ankush]
    if (all_day?.value == true) {
      s_sti?.clearValidators();
      e_eti?.clearValidators();
    } else {
      s_sti?.setValidators([Validators.required]);
      e_eti?.setValidators([Validators.required]);
    }

    all_day?.valueChanges.subscribe((val) => {
      if (val == true) {
        s_sti?.clearValidators();
        e_eti?.clearValidators();
      } else {
        s_sti?.setValidators([Validators.required]);
        e_eti?.setValidators([Validators.required]);
      }
      s_sti?.updateValueAndValidity();
      e_eti?.updateValueAndValidity();
    });
    s_sti?.updateValueAndValidity();
    e_eti?.updateValueAndValidity();
  }

  //  applyConditionalValidation(control: AbstractControl) {
  //   const s_sti = control.get('s_sti');
  //   const e_eti = control.get('e_eti');
  //   const all_day = this.addForm.get('all_day')?.value;
  //   // all_day?.valueChanges.subscribe((val) => {
  //   if (all_day == true) {
  //     s_sti?.clearValidators();
  //     e_eti?.clearValidators();
  //   } else {
  //     s_sti?.setValidators([Validators.required]);
  //     e_eti?.setValidators([Validators.required]);
  //   }
  //   s_sti?.updateValueAndValidity();
  //   e_eti?.updateValueAndValidity();
  //   // });
  // }

  removeDates(index: number): void {
    this.shiftDatesFb.removeAt(index);
  }
  setFormArray(data: any[]) {
    // if you make any changes in this function please make sure you make and check setFormArray function also
    const formArray = this.shiftTasks;
    data.forEach(item => {
      formArray.push(this.fb.group({
        task: new FormControl(item.task, [Validators.required]),
        id: new FormControl(item.id, [Validators.required]),
        j_id: new FormControl(item.j_id, [Validators.required]),
        comm_id: new FormControl(item.comm_id, [Validators.required]),
      }));
    });
  }
  setFormArrayQue(data: any[]) {
    // if you make any changes in this function please make sure you make and check setFormArray function also
    const formArray = this.shiftQue;
    data.forEach(item => {
      formArray.push(this.fb.group({
        question: new FormControl(item.question, [Validators.required]),
        id: new FormControl(item.id, [Validators.required]),
        j_id: new FormControl(item.j_id, [Validators.required]),
        comm_id: new FormControl(item.comm_id, [Validators.required]),
      }));
    });
  }
  setFormArrayDate(data: any[]) {
    // if you make any changes in this function please make sure you make and check setFormArray function also
    // const formArray = this.shiftTasks;
    // data.forEach(item => {
    //   formArray.push(this.fb.group({
    //     task: new FormControl(item.task, [Validators.required]),
    //   }));
    // });
  }
  addTasks(): void {
    // if you make any changes in this function please make sure you make and check setFormArray function also
    const taskForm = this.fb.group({
      'task': ['', Validators.required],
      'id': '',
      'j_id': '',
      'comm_id': ""
    });
    this.shiftTasks.push(taskForm);
  }
  addQuestions(): void {
    const que = this.fb.group({
      'question': ['', Validators.required],
      'id': '',
      'j_id': '',
      'comm_id': ""
    });
    this.shiftQue.push(que);
  }
  removeTasks(index: number): void {
    this.shiftTasks.removeAt(index);
  }
  removeQue(index: number): void {
    this.shiftQue.removeAt(index);
  }
  customSearchFn(term: string, item: any) {
    term = term.toLowerCase();
    return item.first_name.toLowerCase().indexOf(term) > -1 || item.last_name.toLowerCase().indexOf(term) > -1;
  }
  onCurrentTab(type: string) {
    this.currentTab = type;
    if (this.currentTab == 'shift_request') {
      this.shiftRequestList()
    }
    else if (this.currentTab == 'shift_sent') {
      this.onShiftSentList()
    }
    else if (this.currentTab == 'template') {
      // if(this.templateArr.length)
      this.getTemplateList();
    }
    else if (this.currentTab == 'activity') {
      this.getActivity()
    }
    else {
    }
  }
  getActivity() {

    let obj = {
      j_id: this.idObj.j_id
    }

    this.jobService.getShiftActivity(obj).subscribe({
      next: (success: any) => {
        // this.spinner.hide();
        if (success.status == 200) {
          this.activityArr = success.msg;

        }
      },
      error: (error: any) => {

      }
    })

  }
  getCategoryList() {
    this.recruiterService.getCategoryList({}).subscribe({
      next: (success: any) => {
        this.categoryArr = [];
        this.subCategoryArr = [];
        if (success.msg) {
          this.categoryArr = success.msg;
          this.subCategoryArr = [];
          // this.subCategoryArr = this.categoryArr[0].sub_category;
          this.setViewData()
          if (this.shiftType == 'shift_template') {
            this.onSelectTemplate(this.dialogData.item)
          }
        }
      },
      error: (error: any) => {
        this.commonService.handleError(error);
      },
    });
  }
  setViewData() {
    if (this.dialogData.hasOwnProperty('viewType')) {
      let viewData = {
        category: ['j_c', 'j_sc'],
        location: ['add'],
        user: ['em_i'],
        company: ['co_i'],
        c_category: ['co_i', 'j_c', 'j_sc'],
        c_user: ['co_i', 'em_i']
      };
      viewData[this.dialogData.viewType].forEach(field => {
        if (field == 'j_c') {
          let catItem = this.categoryArr.find((item) => item.j_c == this.dialogData[field]);
          if (catItem) {
            this.subCategoryArr = catItem.sub_category;
          }
        }
        this.addForm.get(field)?.setValue(this.dialogData[field]);
      });
    }
  }
  onSelectCategory(event) {
    let catItem = this.categoryArr.find((item) => item.j_c == event.value);
    this.subCategoryArr = [];
    this.addForm.get('j_sc')?.setValue('')
    if (catItem) {
      this.subCategoryArr = catItem.sub_category;
      this.checkAllCriteriaEmp()
    }
  }
  onSelectSubCat(event) {
    this.checkAllCriteriaEmp()
    this.getEmployeeList()
  }
  onCancel() {
    this.dialogRef.close()
  }
  onAddLocation() {
    if (this.userType == 'recruiter') {
      const dialogRef = this.dialog.open(CompanyLocationComponent, {
        width: '75%',
        height: 'auto',
        maxWidth: '1090px',
        panelClass: 'addCourseModal',
        enterAnimationDuration: '200ms', exitAnimationDuration: "200ms",
        autoFocus: false
      });
      dialogRef.afterClosed().subscribe(result => {


        if (result && result.confirm == 'yes') {
        }
        this.getCompanyList()
      });
    }
    else {
      const dialogRef = this.dialog.open(AddLocationComponent, {
        width: '80%',
        minWidth: '300px',
        height: '98%',
        maxHeight: '690px', maxWidth: '800px',
        autoFocus: false,
        // minHeight:'200px'
      });
      dialogRef.afterClosed().subscribe(result => {
        if (result && result.confirm == 'yes' && result.add) {
          this.addForm.get('add')?.setValue(result.add)
          this.getAddressDetails();
          setTimeout(() => {
            this.onChangeAddress({ value: result.add });
          }, 500)

        }
      });
    }
  }
  dateClass: MatCalendarCellClassFunction<Date> = (cellDate, view) => {
    if (view == 'month') {
      let dateToFind = this.getDateOnly(cellDate)
      let i = this.shiftDatesFb.value.findIndex(index => index.date == dateToFind)
      // let i = this.selectedDates.indexOf(dateToFind);
      if (i >= 0) {
        return 'selected'
      }
    }
    return ''
  }
  daySelected(date: Date | null, calendar: any) {
    if (date) {
      let dateSelected = this.getDateOnly(date);
      let i = this.shiftDatesFb.value.findIndex(index => index.date == dateSelected)
      this.addForm.get('st_dt')?.setValue(dateSelected);
      const datesForm = this.fb.group({
        //'date': ['', Validators.required],
        'display_dt': [this.getDispalyDateOnly(date), Validators.required],
        'date': [dateSelected, Validators.required],
        's_sti': ['', Validators.required],
        'e_eti': ['', Validators.required],
      });
      this.applyConditionalValidation(datesForm)
      if (i >= 0) {
        // const index = this.selectedDates.findIndex(obj => obj.date === dateSelected);
        // this.selectedDates.splice(i, 1)
        const index = this.shiftDatesFb.value.findIndex(index => index.date == dateSelected);
        this.shiftDatesFb.removeAt(index);
      } else {
        this.shiftDatesFb.push(datesForm);
      }
      calendar.updateTodaysDate();
    }
    if (this.shiftDatesFb.value.length > 1) {
      this.isNoRepeat = true;

      if (this.repeatData) {
        this.repeatData.repeat = '0';
      }
      this.repeatText = ''
    } else {
      this.isNoRepeat = false;
    }

  }
  remove(dateSelected, calendar) {
    // let i = this.selectedDates.indexOf(dateSelected)
    // this.selectedDates.splice(i, 1)
    const index = this.shiftDatesFb.value.findIndex(index => index.date == dateSelected)
    if (index !== -1) {
      this.shiftDatesFb.removeAt(index);
      // this.shiftDatesFb.value.splice(index, 1);
    }
    calendar.updateTodaysDate();
    if (this.shiftDatesFb.value.length > 1) {
      this.isNoRepeat = true;
      if (this.repeatData) {
        this.repeatData.repeat = '0';
      }
      this.repeatText = ''
    } else {
      this.isNoRepeat = false;
    }
  }
  getDateOnly(date: Date): string | null {
    return this.datePipe.transform(date, "yyyy-MM-dd");
  }
  getDispalyDateOnly(date: Date): string | null {
    // return date.toLocaleString();
    return this.datePipe.transform(date, "dd/MM/yyyy");
  }
  onScheduleShift() {
    const dialogRef = this.dialog.open(RosterShiftComponent, {
      enterAnimationDuration: '300ms', exitAnimationDuration: "300ms", minWidth: '300px', width: '30%',
      // minHeight:'200px'
      data: this.repeatData
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        let fData = result.data;
        if (result.data) {
          this.repeatData = result.data.data;
          this.repeatText = result.data.repeatText;
        }
      }
    });
  }
  onConfirmationModal(element, type) {
    if (element.app == type) { return }
    let data = {
      type: "shift_request",
      text: "status",
      reqObj: {
        app: type, //1 : accep, 0:reject
        em_i: element.em_i,
        j_id: this.idObj.j_id,
      },
      data_type: "change"
    }
    const dialogRef = this.dialog.open(RecConfirmModalComponent, {
      enterAnimationDuration: '300ms', exitAnimationDuration: "300ms", data: data,
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result && result["confirm"] == 'yes') {
        this.shiftRequestList()
      }
    });
  }
  onSendToFav(event) {
    this.filterEmployeeArr = [...this.employeeArr]
    if (event.checked == true) {
      // changes are connected to ngOnit and onSendToFav
      this.filterEmployeeArr = this.filterEmployeeArr.filter(item => item.is_f == 1)
    }
  }
  onPageSizeChange(event: Event, type: string) {
    const tar = event.target as HTMLInputElement
    this.objData[type].itemsPerPage = Number(tar.value);
    this.objData[type].currentPage = 1;
    // this.noticesList()

    if (type == 'shiftSent') {
      this.onShiftSentList()
    }
    if (type == 'shiftREquest') {
      this.shiftRequestList()
    }
  }
  onPageChange(number: number, type: string) {
    this.config.currentPage = number;

    this.objData[type].currentPage = number;
    if (type == 'shiftSent') {
      this.onShiftSentList()
    }
    if (type == 'shiftREquest') {
      this.shiftRequestList()
    }
    // this.noticesList()
  }
  shiftRequestList() {

    // this.dataSource.paginator = this.paginator;
    // this.dataSource.sort = this.sort;
    const obj = {
      j_id: this.idObj.j_id,
      f_a: this.objData.shiftREquest.arr,
      op_nd: this.objData.shiftREquest.operand,
      sh: this.objData.shiftREquest.sh,
      st: this.appService.startPageLogic(
        this.objData.shiftREquest.currentPage,
        this.objData.shiftREquest.itemsPerPage
      ),
      r_p: this.objData.shiftREquest.itemsPerPage,
    }
    this.objData.shiftREquest.previousInputValue = this.objData.shiftREquest.sh;


    this.isSpinnerLoading2 = true
    this.jobService.getShiftReqList(obj).subscribe({
      next: (success: any) => {
        // this.spinner.hide();
        // this.isSpinnerLoading = false
        if (success.status == 200) {
          // this.previousInputValue = this.searchInput;
          this.objData.shiftREquest.count = success.count
          this.dataSource = new MatTableDataSource(success.msg.j_d.employee_data)
          // this.dataSource.paginator = this.paginator;
          // this.dataSource.sort = this.sort;
          this.isSpinnerLoading2 = false

        }
      },
      error: (error: any) => {
        this.isSpinnerLoading2 = false
        this.commonService.handleError(error)
      }
    })
  }
  onViewPastShift(element) {
    const dialogRef = this.dialog.open(ViewPastHistoryComponent, {
      enterAnimationDuration: '300ms', exitAnimationDuration: "300ms", minWidth: '280px', width: '60%',
      data: element,
    });
    dialogRef.afterClosed().subscribe(result => {
    });
  }
  onViewQuestion(element) {
    const dialogRef = this.dialog.open(ViewQuestionAnswerComponent, {
      enterAnimationDuration: '300ms', exitAnimationDuration: "300ms", minWidth: '280px', width: '60%',
      data: element,
    });
    dialogRef.afterClosed().subscribe(result => {
    });
  }
  onShiftSentList() {
    const data = {
      j_id: this.idObj.j_id,
      f_a: this.objData.shiftSent.arr,
      op_nd: this.objData.shiftSent.operand,
      sh: this.objData.shiftSent.sh,
      st: this.appService.startPageLogic(
        this.objData.shiftSent.currentPage,
        this.objData.shiftSent.itemsPerPage
      ),
      r_p: this.objData.shiftSent.itemsPerPage,
    }
    this.objData.shiftSent.previousInputValue = this.objData.shiftSent.sh;
    this.isSpinnerLoading = true
    this.jobService.getShiftSentList(data).subscribe({
      next: (success: any) => {
        if (success["status"] == 200) {
          this.objData.shiftSent.count = success.count;
          if (success.cron_record != 0) {
            this.shiftSentCrone = true;
          }
          this.dataSourceShiftSent = new MatTableDataSource(success.msg)
          this.isSpinnerLoading = false

        }

        if (success.cron_record != 0) {
          this.shiftSentCrone = true;
        } else {
          this.shiftSentCrone = false;
        }
      },
      error: (error: any) => {
        this.isSpinnerLoading = false
        // if (error.cron_record != 0) {
        //   this.shiftSentCrone = true;
        // } else {
        //   this.shiftSentCrone = false;
        // }
        // this.spinner.hide();
        this.commonService.handleError(error);
      },
    });
  }
  onMoreIconClick(event: Event): void {
    event.stopPropagation();
    // This prevents the click event from propagating to the parent element
    // so it won't trigger the onSelectTemplate method.
  }
  onSelectTemplate(item) {
    this.currentTab = "shift_details"
    //set the selected template value in the shift details
    Object.keys(item).forEach(key => {
      if (key in this.addForm.value) {
        this.addForm.get(key)?.setValue(item[key]);
        // slicing the minutes as otherwise it was not working
        if (key == 'st_ti' || key == 'ed_ti') {
          this.addForm.get(key)?.setValue(item[key].slice(0, 5))
        }
      }
    });
    let catItem = this.categoryArr.find((i) => i.j_c == item.j_c);
    this.subCategoryArr = [];
    if (catItem) {
      this.subCategoryArr = catItem.sub_category;
      this.addForm.get('j_sc')?.setValue(item.j_sc)
    }
  }
  getAddressDetails() {
    this.recruiterService.getDetails().subscribe({
      next: (success: Object) => {
        if (success["status"] == 200) {
          this.locArr = []
          this.locArr = success["msg"]["company_info"]["company_add"];

          this.dressCodeArr = []
          this.dressCodeArr = success["msg"]["uniform"];

          this.setViewData()
        }
      },
      error: (error: any) => {
        // this.spinner.hide();
        this.commonService.handleError(error);
      },
    });
  }
  onChangeAddress(event) {
    let addItem = this.locArr.find(item => item.add == event.value)
    this.addForm.get('lat')?.setValue(addItem?.lat)
    this.addForm.get('long')?.setValue(addItem?.long)
    this.addForm.get('city')?.setValue(addItem?.city)
    this.addForm.get('country')?.setValue(addItem?.country)
    this.addForm.get('prop_n')?.setValue(addItem?.prop_n)
  }
  getJobDetails() {
    this.spinner.show()
    let dataObj = {};
    dataObj["j_id"] = this.idObj.j_id;
    dataObj["em_i"] = this.idObj.em_i;
    if (!this.idObj.em_i) {
      dataObj["em_i"] = ""
    }
    dataObj["comm_id"] = this.idObj.comm_id;
    this.jobService.viewJobDetails(dataObj).subscribe({
      next: (success: Object) => {
        if (success["status"] == 200) {
          this.spinner.hide()
          let shiftData: any = success;
          let jobData = success["msg"]["j_d"][0];
          for (let [key, value] of Object.entries(jobData)) {
            let formValue = this.addForm.get(key);
            if (formValue && (key != 'shift_task' && key != 'que')) {
              if (key === 'st_ti' || key === 'ed_ti') {
                if (typeof value === 'string' && value.length >= 3) {
                  let newValue = value.slice(0, -3);
                  formValue.setValue(newValue);
                }
              } else {
                formValue.setValue(value);
              }
            }
          }
          let catItem = this.categoryArr.find((item) => item.j_c == jobData.j_c);
          this.subCategoryArr = [];
          if (catItem) {
            this.subCategoryArr = catItem.sub_category;
          }
          this.addForm.get('j_sc')?.setValue(jobData['j_sc'])
          this.setFormArray(jobData.shift_task);
          //adding this question if data then set or else not
          if (jobData.que) {
            this.setFormArrayQue(jobData.que);
          }
          if (this.dialogData.modalType == 'open_shift' || this.dialogData.modalType == 'edit') {
            //whenever there is edit shift then be it either the open_shift or normal user assigned shift then by default 
            //the employee for whom the shift is already assigned will be shown as selected.
            setTimeout(() => {
              if (this.employeeListFlag) return;
              this.getEmployeeList();
            }, 400);
            this.addForm.get('emp')?.setValue(success["msg"]["j_d"]["emp"]);
          }

          this.addForm.get('rec')?.setValue(success["msg"]["j_d"]["recruiter_ids"]);

          const recruiterIdsFromObjects = this.filterRecArr?.map(r => r.company_id) || [];
          const idsToMatch = success?.["msg"]?.["j_d"]?.["recruiter_ids"] || [];
          if (Array.isArray(recruiterIdsFromObjects) && Array.isArray(idsToMatch)) {
            const allMatch = idsToMatch.every(id => recruiterIdsFromObjects.includes(id)) &&
              idsToMatch.length === recruiterIdsFromObjects.length;
            this.addForm.get('s_rec')?.setValue(allMatch);

          }

          if (jobData.repeat == "1" || jobData.repeat == 1) {
            // if it is repeating shift then add the data here, in case user needs to edit then we will need to append data to the 
            //Roster shift component.
            this.repeatData = {
              "repeat": jobData["repeat"], //1 = yes, 0 = no
              "r_typ": jobData["r_typ"], //2=daily,1=weekly,0=monthly,
              "r_val": jobData['r_val'], //every some times 
              "r_on": JSON.parse(jobData['r_on']), //[0,2,1] = weekly 
              "end_rtyp": jobData['end_rtyp'], // 1=after, 0=on
              "end_r": jobData['end_r'],
              "api": true
            }
            this.repeatText = jobData["r_txt"]
          }
        }
      },
      error: (error: any) => {
        // this.spinner.hide();
        this.commonService.handleError(error);
      },
    });
  }
  onDeleteShift() {
    const dialogRef = this.dialog.open(DeleteItemComponent, Object.assign({
      data: { api_type: "delete_content", content_type: "delete_shift", id: this.idObj.j_id, comm_id: this.idObj.comm_id }
    },));
    dialogRef.afterClosed().subscribe(result => {
      if (result && (result["delete_content"] == true)) {
        // this.noticesList()
        this.dialog.closeAll()
      }
    });
  }
  getEmployeeList() {
    let data = {
      "all_day": this.addForm.get('all_day')?.value,
      "st_dt": this.datePipe.transform(this.addForm.get('st_dt')?.value, 'yyyy-MM-dd'),
      "st_ti": this.addForm.get('st_ti')?.value,
      "ed_ti": this.addForm.get('ed_ti')?.value,
      "date": this.addForm.get('date')?.value,
      "j_c": this.addForm.get('j_c')?.value,
      "j_sc": this.addForm.get('j_sc')?.value,
      "e_typ": "1", // 2 = favourite , 1 = all employee
      "co_i": this.selectedCompanyId
    }
    if (data && this.dialogData.addType != 'assign_fav_employee') {
      data['all_emp'] = 1;
    }
    if (!this.addForm.get('st_dt')?.value) {
      data["st_dt"] = "";
    }
    if (this.addForm.get('j_sc')?.value) {
      data['all_emp'] = 0;
    }
    if (this.shiftType == "assign_fav_employee") {
      data["e_typ"] = "2";
      data['all_emp'] = 0;
    }
    else if (this.shiftType == "additional_resource") {
      // if additional resource and selected employee is favorites
      if (this.addForm.get('rec_emp_typ')?.value == 1) {
        data["e_typ"] = "1"; //rec_emp_typ = 1 :: Send to Favorites
      }
      else {
        data["e_typ"] = "2";
      }
    }
    else if (this.dialogData.addType == 'assign_fav_employee') {
      data["e_typ"] = "2";
      data['all_emp'] = 0;
    }
    else {
      data["e_typ"] = "1";
    }
    this.spinner.show();
    this.jobService.getEmployee(data).subscribe({
      next: (success: any) => {
        this.spinner.hide();
        if (success["status"] == 200) {
          this.employeeArr = []
          this.employeeArr = [...(success["msg"]["avl"] ?? []), ...(success["msg"]["un_avl"] ?? [])];
          this.filterEmployeeArr = [...this.employeeArr];
          // here to have select all option we need to group by same key i.e 'e'
          this.filterEmployeeArr = this.filterEmployeeArr.map((item) => {
            item['fullName'] = item.first_name + ' ' + item.last_name
            item["e"] = '';  // Modify the object
            return item;     // Return the modified object
          });


          if (this.dialogData.viewType === 'user' || this.dialogData.viewType === 'c_user') {
            let newArr: any[] = [];
            newArr.push(this.dialogData.em_i);
            this.addForm.get('emp')?.setValue(newArr);
            this.addForm.get('qty')?.setValue(1);
          }
        }
      },
      error: (error: any) => {
        this.commonService.handleError(error);
      },
    });
  }
  onSaveTemplate() {
    if (this.addForm.invalid) {
      this.addForm.markAllAsTouched();
      return;
    }
    else {

      // return
      let newArr: JobDataAdd[] = [];
      let jobObj: JobDataAdd = this.addForm.value;
      delete jobObj["s_rec"];
      delete jobObj["fav_emp_typ"];
      delete jobObj["rec_emp_typ"];
      delete jobObj["own_emp_typ"];
      delete jobObj["own_emp_typ"];

      jobObj.ins_h = this.addForm.get('ins_h')?.value ? "1" : "0";
      jobObj.shift = "shift";
      jobObj.ed_dt = this.datePipe.transform(jobObj['st_dt'], 'yyyy-MM-dd');
      jobObj.st_dt = this.datePipe.transform(jobObj['st_dt'], 'yyyy-MM-dd');

      var u_type, e_typ, assign;
      if (this.shiftType == "assign_fav_employee") {
        u_type = 1;
        e_typ = 1;
        assign = this.addForm.get('fav_emp_typ')?.value;
      }
      else if (this.shiftType == 'additional_resource') {
        u_type = this.addForm.get('user_type')?.value;
        assign = 0;
        e_typ = this.addForm.get('rec_emp_typ')?.value;
      }
      else {
        u_type = 1;
        e_typ = 0;
        assign = this.addForm.get('own_emp_typ')?.value;
      }
      jobObj.assign = assign;
      jobObj.e_typ = e_typ;
      delete jobObj['user_type'];
      newArr.push(jobObj);
      let data = {
        "st_dt": this.datePipe.transform(jobObj['st_dt'], 'yyyy-MM-dd'),
        "ed_dt": this.datePipe.transform(jobObj['st_dt'], 'yyyy-MM-dd'),
        "type": "3", // 0 = shift, 1 = week template, 2 = day template, 3 = shift template
        "name": "",
        "j_d": newArr,
        "u_t": u_type,
      }
      if (data.st_dt == null || data.st_dt == undefined) {
        data.st_dt = this.addForm.get('data')?.value[0]["date"]
      }
      if (data["j_d"][0]["st_dt"] == null || data["j_d"][0]["st_dt"] == undefined) {
        data["j_d"][0]['st_dt'] = data["j_d"][0]["date"][0]["date"]
      }
      this.spinner.show();
      // if(this.isEditTemplate==false){

      if (this.dialogData?.modalType == 'edit_template') {

        data.name = this.dialogData.name;
        data['comm_id'] = this.dialogData.comm_id;

        this.jobService.editTemplate(data).subscribe({
          next: (success: any) => {
            if (success["status"] == 200) {
              this.spinner.hide();
              this.appService.showToastMessage("success", success.msg);
              this.dialogRef.close({ saveTemplate: true });
            }
          },
          error: (error: any) => {
            this.spinner.hide();
            this.commonService.handleError(error);
          },
        });
      } else {
        this.jobService.saveTemplate(data).subscribe({
          next: (success: any) => {
            if (success["status"] == 200) {
              this.spinner.hide();
              this.appService.showToastMessage("success", success.msg);
              this.dialogRef.close({ saveTemplate: true });
            }
          },
          error: (error: any) => {
            this.spinner.hide();
            this.commonService.handleError(error);
          },
        });
      }


    }
  }
  onSubmit() {
    if (this.addForm.invalid) {
      this.addForm.markAllAsTouched();
      return;
    }
    else {

      if (this.shiftType == 'additional_resource') {
        this.onJobSummary();

      }
      else {
        if (this.addForm.get('qty')?.value < this.addForm.get('emp')?.value.length) {
          this.appService.showToastMessage('error', this.errorType.qty)

        }
        else {

          if (this.idObj.j_id) {
            this.onEditJobSubmit();

          }
          else {

            this.onAddShift();
          }
        }
      }
    }
  }
  getShiftData() {
    let data = {
      "sh_typ": "2", //2= shift, 1= flexible, 0 = full job  
      "u_t": "0", // 2= recruiter employee, 1 = own employee, 0 = freelance employee 
    }
    if (this.repeatData) {
      data = Object.assign(data, this.repeatData)
      data["r_txt"] = this.repeatText;
    }
    else {
      data["repeat"] = 0;
      data["r_typ"] = '';
      data["r_val"] = '';
      data["r_on"] = '';
      data["end_rtyp"] = '';
      data["end_r"] = '';
      data["r_txt"] = '';
    }
    if (this.idObj.j_id) {
      data["j_id"] = this.idObj.j_id,
        data["comm_id"] = this.idObj.comm_id,
        data["ed_typ"] = 0
    }


    if (!this.addForm.get('rec')?.value || this.addForm.get('s_rec')?.value == 1) {
      this.addForm.get('rec')?.setValue([]);
    }


    let newArr: JobDataAdd[] = [];
    let jobObj: JobDataAdd = this.addForm.value;


    delete jobObj["s_rec"];
    delete jobObj["fav_emp_typ"];
    delete jobObj["rec_emp_typ"];
    delete jobObj["own_emp_typ"];
    delete jobObj["own_emp_typ"];

    jobObj.ins_h = this.addForm.get('ins_h')?.value ? "1" : "0";
    jobObj.shift = "shift";
    jobObj.ed_dt = this.datePipe.transform(jobObj['st_dt'], 'yyyy-MM-dd');
    jobObj.st_dt = this.datePipe.transform(jobObj['st_dt'], 'yyyy-MM-dd');
    // ng Multiselect dropdown is used here. so here it takes as an array so manage it like wise.
    if (typeof (jobObj.add) == 'object') {
      jobObj.add = jobObj.add[0]["add"];
    }
    var u_type, e_typ, assign, rec;

    if (this.shiftType == "assign_fav_employee") {
      u_type = 1;
      e_typ = 1;
      assign = this.addForm.get('fav_emp_typ')?.value;

    }
    else if (this.shiftType == 'additional_resource') {
      u_type = this.addForm.get('user_type')?.value;
      assign = 0;
      e_typ = this.addForm.get('rec_emp_typ')?.value;

      if (!this.addForm.get('rec')) {
        rec = [];
      }
    }
    else {
      u_type = 1;
      e_typ = 0;
      assign = this.addForm.get('own_emp_typ')?.value;
    }


    //if u_typ is 1 in local storage userinfo 
    const userInfo = JSON.parse(this.appService.getData('training-portal.userInfo'));
    if (userInfo?.u_typ == 1) {
      u_type = 2;
    }

    jobObj.assign = assign;
    jobObj.e_typ = e_typ;
    jobObj.prop_n = "";
    delete jobObj['user_type'];

    newArr.push(jobObj);

    data["j_d"] = newArr;
    data["u_t"] = u_type;
    // if (this.userType==='company') {
    //   data["j_d"][0]["co_i"]="";
    // }

    return data
  }
  onAddShift() {
    this.isSaving = true
    if (this.addForm.get('qty')?.value < this.addForm.get('emp')?.value.length) {
      this.appService.showToastMessage('error', this.errorType.qty)
    }
    else {
      let data = this.getShiftData()
      this.spinner.show();
      this.jobService.createJob(data).subscribe({
        next: (success: any) => {
          if (success["status"] == 200) {

            this.spinner.hide();
            this.appService.showToastMessage("success", success.msg);
            this.dialogRef.close();
          }
        },
        error: (error: any) => {
          this.isSaving = false;
          this.spinner.hide();
          this.commonService.handleError(error);
        },
      });
    }
  }
  onEditJobSubmit() {
    let data = this.getShiftData()
    if (data["repeat"] == 1) {
      this.onSchedulerEdit(data);
    }
    else {
      this.onEditJobAPI(data);
    }
  }
  onEditJobAPI(data) {
    this.isSaving = true
    this.spinner.show();
    this.jobService.editJobDetails(data).subscribe({
      next: (success: any) => {
        if (success["status"] == 200) {
          this.spinner.hide();
          this.appService.showToastMessage("success", success.msg);
          this.dialogRef.close();


        }
      },
      error: (error: any) => {
        this.isSaving = false
        this.commonService.handleError(error);
      },
    });
  }
  onSchedulerEdit(item) {
    const dialogRef = this.dialog.open(ScheduleShiftConfirmationComponent, {
      enterAnimationDuration: '300ms', exitAnimationDuration: "300ms", minWidth: '280px', maxWidth: '380px', height: 'auto'
      // minHeight:'200px'
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result && result.data) {
        item["ed_typ"] = result.data
        this.onEditJobAPI(item)
      }
    });
  }
  onJobSummary() {


    const dialogRef = this.dialog.open(JobSummaryComponent, {
      height: '98%',
      width: '100%',
      maxWidth: '550px',
      maxHeight: '',
      // data: this.addForm.value,
      data: {
        formData: this.addForm.value,
        repeatData: this.repeatData
      }
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result.confirm == "yes") {
        this.onAddShift();
        this.dialogRef.close()
      }
    });
  }
  getCompanyList() {
    let data = {
      need: 2  // 1 = company list, 2 = address with company list
    }
    this.jobService.viewCompanyLocation(data).subscribe({
      next: (success: Object) => {
        if (success["status"] == 200) {
          this.companyArr = []
          this.companyArr = success["msg"]
          if (this.addForm.get('co_i')?.value) {
            const selectedCmp = this.companyArr.find(item => item.co_i == this.addForm.get('co_i')?.value)
            this.selectedCompanyId = selectedCmp.co_i;
            this.locArr = []
            if (selectedCmp) {
              this.locArr = selectedCmp.add;
            }
          }
          this.setViewData()
        }
      },
      error: (error: any) => {
        this.commonService.handleError(error);
      },
    });
  }
  onSelectCompany(value) {
    const selectedCmp = this.companyArr.find(item => item.co_i == value.value)
    this.selectedCompanyId = selectedCmp.co_i;
    this.locArr = []
    this.locArr = selectedCmp.add;
    if (this.userType === "admin" || this.userType === "recruiter" || this.adminType === 'admin') {
      this.getEmployeeList();
    }
  }
  onTimeChanged() {
    this.checkAllCriteriaEmp();
  }
  onAllDayChanged(event) {
    let value = event.checked;
    if (!value && this.dialogData.addType == 'single') {
      this.addForm.get('st_ti')?.setValidators([Validators.required])
      this.addForm.get('ed_ti')?.setValidators([Validators.required])
    } else {
      this.addForm.get('st_ti')?.setValidators([])
      this.addForm.get('st_ti')?.clearValidators()
      this.addForm.get('st_ti')?.setErrors(null)

      this.addForm.get('ed_ti')?.setErrors(null)
      this.addForm.get('ed_ti')?.setValidators([])
      this.addForm.get('ed_ti')?.clearValidators()
    }
    this.addForm.updateValueAndValidity()
    this.checkAllCriteriaEmp();
  }
  checkAllCriteriaEmp() {
    // call the get employee list API only if  all the required shift details are filled in the form 
    // if the shift edit modal is open then no need to check the below criteria and call the api.
    if (this.dialogData.modalType == 'edit') { return }
    const form = this.addForm;
    // single : start date, start time and  end time is necessary 
    const isValidForm = (this.shiftType === 'single' && form.get('st_ti')?.value && form.get('ed_ti')?.value && form.get('st_dt')?.value) ||
      ((this.shiftType === 'multiple' || this.shiftType === 'assign_fav_employee') && form.get('all_day')?.value && this.shiftDatesFb.length > 0 ||
        !form.get('all_day')?.value && form.get('date')?.valid && this.shiftDatesFb.length > 0)
    if (isValidForm && form.get('j_c')?.value && form.get('j_sc')?.value) {
      return this.getEmployeeList();
    }
    else {
      return;
    }
  }
  getRecruiterList() {
    if (this.userType == "recruiter" || this.userType == "admin") return;
    const data = {}
    this.spinner.show()
    this.jobService.recruiterList(data).subscribe({
      next: (success: any) => {
        this.spinner.hide();
        if (success["status"] == 200) {
          this.recruiterArr = [...(success["data"])];
          this.filterRecArr = [...this.recruiterArr];
        }
      },
      error: (error: any) => {
        this.commonService.handleError(error);
      },
    });
  }
  // ALL TEMPLATE RELATED==============

  getTemplateList() {
    const data = {
      "type": "3" // 0 = shift, 1 = week template, 2 = day template, 3 = shift template
    }
    this.spinner.show();
    this.jobService.getTemplate(data).subscribe({
      next: (success: any) => {
        this.spinner.hide();
        if (success["status"] == 200) {
          this.templateArr = [];
          this.templateArr = success.msg;
        }
      },
      error: (error: any) => {
        this.commonService.handleError(error);
      },
    });
  }
  onDeleteTemplate(item) {
    const dialogRef = this.dialog.open(DeleteItemComponent, Object.assign({
      data: { api_type: "delete_content", content_type: "delete_shift_template", id: item.comm_id }
    },));
    dialogRef.afterClosed().subscribe(result => {
      if (result && (result["delete_content"] == true)) {
        // this.noticesList()
        // this.dialog.closeAll()
        this.getTemplateList();
      }
    });
  }
  onEditTemplate(item) {
    var data = {
      addType: "single",
      modalType: "edit_template"
    }
    data = Object.assign(item, data);
    const dialogRef = this.dialog.open(AddShiftComponent, {
      enterAnimationDuration: '300ms', exitAnimationDuration: "300ms",
      width: '55%', height: '98%',
      maxWidth: '90vw',
      autoFocus: false,
      data: data
    });
    dialogRef.afterClosed().subscribe(result => {
      this.getTemplateList()
    });
  }
  autoReject() {
    const data = {
      "j_id": this.idObj.j_id
    }
    this.spinner.show()
    this.jobService.autoRejectAll(data).subscribe({
      next: (success: any) => {
        this.spinner.hide();
        if (success["status"] == 200) {
          this.appService.showToastMessage('success', success["msg"])
        }
      },
      error: (error: any) => {
        this.commonService.handleError(error);
      },
    });
  }

  acceptAll() {
    const data = {
      "j_id": this.idObj.j_id
    }
    this.spinner.show()
    this.recruiterService.onAcceptAllUserForSpecificJob(data).subscribe({
      next: (success: any) => {
        this.spinner.hide();
        if (success["status"] == 200) {
          this.appService.showToastMessage('success', success["msg"])
          this.shiftRequestList()
        }
      },
      error: (error: any) => {
        this.commonService.handleError(error);
      },
    });
  }

  getEmpValue(event: any) {
    this.addForm.get('emp')?.setValue(null);
    if (event.value == '1') {
      this.getEmployeeList()
      this.addForm.markAllAsTouched();
    } else {

    }
  }

  checkUrl(url: any) {
    let newUrl;
    if (url?.includes("https")) {
      newUrl = url;
    } else {
      newUrl = GlobalService.imageURL + url;
    }
    return newUrl;
  }

  onScrollBottom() {
    // console.log('hello world')
  }

  onViewEmployee(id) {
    let data = {
      employee_id: id,
      type: 'company'
    }
    const dialogRef = this.dialog.open(ViewEmployeeComponent, {
      width: '95%',
      height: '95vh',
      maxWidth: '95vw',
      panelClass: 'onboard-modal',
      data: data,
      enterAnimationDuration: '300ms', exitAnimationDuration: "300ms"
    });

    dialogRef.afterClosed().subscribe(result => {
    });
  }
}